import { apiFetch } from './api';

// A stored file of the company, fetched through the backend (which checks the session and the company) as bytes. No address is ever handed out.
// -> a Blob, or null when it could not be read.
export async function fetchStoredFile(documentId) {
  try {
    const res = await apiFetch('/api/documents/file', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: documentId }) });
    if (!res.ok) return null;
    return await res.blob();
  } catch {
    return null;
  }
}

// Opens a stored file in a new tab from the bytes held in this page (the address only lives in this browser tab). True when it opened.
export async function openStoredFile(documentId) {
  const blob = await fetchStoredFile(documentId);
  if (!blob) return false;
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank', 'noopener');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return true;
}
